// extracted by mini-css-extract-plugin
export var fullHeightState = "_54-7";
export var headerCell = "_54-1";
export var loadingStateCell = "_54-4";
export var rowWrapper = "_54-3";
export var standaloneTable = "_54-8";
export var standaloneTableWithBodyFill = "_54-9";
export var stateCell = "_54-5";
export var table = "_54-0";
export var tableBodyFiller = "_54-6";
export var white = "_54-2";